import React, { Component } from 'react';
import $ from 'jquery';

import Header from '../Components/Header';
import Footer from '../Components/Footer';
import About from '../Components/About';

class HomePage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            siteData: {}
        };

    }

    getSiteData() {
        $.ajax({
            url: 'siteData.json',
            dataType: 'json',
            cache: false,
            success: function (data) {
                this.setState({ siteData: data });
            }.bind(this),
            error: function (xhr, status, err) {
                console.log(err);
            }
        });
    }

    componentDidMount() {
        this.getSiteData();
    }

    render() {
        return (
            <div className="App">
                <Header data={this.state.siteData.main} />
                <About data={this.state.siteData.main} />
                <Footer data={this.state.siteData.main} />
            </div>
        );
    }
};

export default HomePage;